import React, { useContext, useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { GetSpaceContext } from '../GetSpaceContext';
import { dateComparator, dateValueFormatter } from '../utils/ag-grid-utils';

ModuleRegistry.registerModules([AllCommunityModule]);


const UsersComponent = () => {

    const users = useContext(GetSpaceContext)

    // Handle deactivate button click
    // const handleDeactivate = (id) => {
    //     alert(`Deactivate user with ID: ${id}`);
    // };

    const pagination = true;
    const paginationPageSize = 20;
    const paginationPageSizeSelector = [20, 30, 40];

    const [colDefs, setColDefs] = useState([
        {
            field: 'sub', headerName: 'ID'
        },
        {
            valueGetter: b => (b.data.name || '') + ' ' + (b.data.surname || ''),
            headerName: 'Полное Имя'
        },
        {
            field: 'iin', headerName: 'ИИН'
        },
        {
            field:'phoneNumber', headerName: 'Номер телефона'
        },
        {
            field: 'email', headerName: 'Email'
        },
        {
            field: 'dateAdded', valueFormatter: b => dateValueFormatter(b.data.dateAdded), headerName: 'Дата регистрации', comparator: dateComparator
        }
    ]);

    return (
        <div className="">
            <h3 className="mb-4">Пользователи: {users.length}</h3>
            <div className='ag-theme-quartz' style={{height: 500}}>
                <AgGridReact
                    rowData={users}
                    columnDefs={colDefs}
                    pagination={pagination}
                    paginationPageSize={paginationPageSize}
                    paginationPageSizeSelector={paginationPageSizeSelector}
                />
            </div>
        </div>
    );
};

export default UsersComponent;
